import { inject, Injectable } from "@angular/core";
import { IncidenceSubtype } from "@dtos/quality/incidents.dto";
import { ApiService } from "@services/api.service";
import { EndPoints } from "@services/EndPoints";



export interface CreateIncidenceRequest {
  comments: string;
  incidence_main_type: string;
  incidence_sub_type: string;
  client_zendesk_link: string;
  driver_zendesk_link: string;
  amount: number;
  driver: number;
  transport: number;
  responsible: number;
  documents: string[];
}

@Injectable({ providedIn: 'root' })
export class IncidencesProvider {
  private readonly api = inject(ApiService);
  

  async getSubtypes(mainType: string): Promise<IncidenceSubtype[] | null> {
    try {
      const result = await this.api.get<IncidenceSubtype[]>({
        url: EndPoints.getIncidenceSubtypes,
        queryParams: { main_type: mainType }
      });
      return result || [];
    } catch (error) {
      console.error('Error al obtener subtipos de incidencia:', error);
      return null;
    }
  }

  async createIncidence(data: Partial<CreateIncidenceRequest>): Promise<any | null> {
    try {
      return await this.api.post<any>({
        url: EndPoints.createIncidence,
        body: data
      });
    } catch (error) {
      console.error('Error al crear incidencia:', error);
      return null;
    }
  }
}
